export const heroText = {
    topline: 'Trusted by 20+ Companies',
    toplineSpan: 'for Secure Cash Transit',
    headline: 'CIT Expertise, Secure Transport,',
    headlineSpan: 'and Trusted Solutions',
    description: 'We deliver expert CIT services with secure transport and reliable solutions, ensuring your assets are protected at all times.',
    btnLabel: 'Contact Us',
    heroImg: './images/hero-image.svg',
    alvacVideo: './images/alvac.mp4'
}

export const aboutText = {
    topline: 'WHY ALVAC',
    headline: 'Alvac: Secure & Reliable Cash in Transit Services You Trust',
    subline:'Provides a full service range',
    description: `Alvac Company Limited specializes in secure and reliable Cash in Transit services, ensuring safe and consistent delivery. We are committed to meeting customer needs with integrity and professionalism.
    Our strong culture of teamwork enables us to uphold our commitment to excellence, providing trusted solutions that prioritize security and efficiency.`,
    btnLabel: 'Contact Us',
    aboutImg: './images/about-image.svg',
}

export const servicesData = [
    {
         id: 1,
         icon: "./images/design.svg",
         title: "Design",
         description: "Agency is a business you hire to outsource your digital marketing efforts, instead of handling in-house.",
         plus: "./images/plus.svg",
         link: "Learn More"
    },
     {
         id: 2,
         icon: "./images/development.svg",
         title: "Development",
         description: "Hire to outsource your digital marketing efforts, instead of handling in-house can provide your business..",
         plus: "./images/plus.svg",
         link: "Learn More"
     },
 ];

export const portfolioText = {
    topline: 'PORTFOLIO',
    headline: 'Latest Work',
    buttonLabel: 'EXPLORE MORE',
}


export const featuresText = {
    topline: 'Features',
    headline: 'Give Your Site A New Look',
    description: `Service range including technical skills, design, business understanding.`,
    img: './images/features-illus.svg',
    icon: './images/check.svg'
}

export const tabsData = [
    {
         id: 1,
         tabTitle: "Our Mission",
         headline: "Our Mission",
         description: "We offer secured, competitive cash logistic anchored on sound process, driven by cutting-edge technology and competent team.",
         tabIcon: './images/mission-icon.svg',
         tabImage: './images/mission-image.svg'
    },
    {
        id: 2,
        tabTitle: "Our Vision",
        headline: "Our Vision",
        description: "To be the recognised leader and the most preffered in the provision of integrated cash manegment solution in the Sub-Sahara Africa.",
        tabIcon: './images/vision-icon.svg',
        tabImage: './images/vision-image.svg'
    },
    {
        id: 3,
        tabTitle: "Our Value",
        headline: "Our Value",
        description: "We offer secured, competitive cash logistic anchored on sound process, driven by cutting-edge technology and competent team.",
        tabIcon: './images/value-icon.svg',
        tabImage: './images/vision-image.svg'
    },

 ];

 export const faqData = [
    {
         id: 1,
         question: "What services does Alvac Company Limited offer?",
         answer: "We specialize in Cash in Transit (CIT), security services, air freight movement, and ATM services to ensure secure financial operations.",
         upIcon: './images/minus.svg',
         downIcon: './images/plus.svg'
    },
    {
        id: 2,
        question: "How secure are your Cash in Transit services?",
        answer: "Our CIT services follow strict security protocols, using armored vehicles, trained personnel, and advanced tracking systems to ensure maximum safety.",
        upIcon: './images/minus.svg',
        downIcon: './images/plus.svg'
   },
   {
        id: 3,
        question: "Do you provide nationwide coverage?",
        answer: "Yes, we operate across multiple locations, ensuring secure cash and asset transportation wherever you need it.",
        upIcon: './images/minus.svg',
        downIcon: './images/plus.svg'
    },
    {
        id: 4,
        question: "How do you ensure the safety of transported funds?",
        answer: "We implement advanced security measures, including real-time tracking, highly trained security teams, and risk management strategies.",
        upIcon: './images/minus.svg',
        downIcon: './images/plus.svg'
    },
    {
        id: 5,
        question: "How can I get started with your services?",
        answer: "You can contact us through our website or customer support to discuss your needs and set up a customized security solution..",
        upIcon: './images/minus.svg',
        downIcon: './images/plus.svg'
    },

 ];

 export const contactText = {
    headline: 'Send us a message',
    description: `Have any questions or need assistance? Reach out to us, and our team will respond promptly to provide the support and information you need.`,
    phone1: '+234-707-469-0941',
    phone2: '+234-810-881-7253',
    phone3: '+01-63111992',
    email: 'Info@alvacng.com',
    address: '55, Adekunle Fajuyi Way, Ikeja GRA, Lagos.',
    linkedin: 'Linkedin',
    phoneImg: './images/phone.svg',
    emailImg: './images/email.svg',
    addressImg: './images/address.svg',
    linkedinImg: './images/linkedin.svg',
    }

 export const bannerText = {
    headline: 'Reliable & Secure Cash Management Solutions',
    description: `We provide trusted CIT, security, air freight, and ATM solutions to keep your assets safe.`,
    btnLabel: 'Contact Us Now',
    img: './images/banner-image.svg',
}




 



